import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";

import DesktopHeader from "./desktop/header";
import MobileHeader from "./mobile/header";
import { theme } from "../../configs/theme";

function Landing() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: `
          radial-gradient(circle at top right, rgba(255,0,0,0.08), transparent 32%),
          linear-gradient(180deg, #f7f7f8 0%, #ececee 100%)
        `,
      }}
    >
      {isMobile ? (
        <MobileHeader theme={theme} />
      ) : (
        <DesktopHeader theme={theme} />
      )}

      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 3 },
          py: { xs: 10, sm: 4 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default Landing;
